module.exports = __webpack_public_path__ + "img/emoji_inactive.253ce695.svg";